<script>
    export let collaborator;
    export let selectedIndex;
    export let ELEMENT_HEIGHT;
    export let onSelect;
    export let index;
    export let workspaceIndex;
    export let currentCounter = 0;
    export let calculateSlackSuggestionIndex;
    export let refElement;

    let calculatedIndex;
    if (index !== undefined && calculateSlackSuggestionIndex) {
        calculatedIndex = index + calculateSlackSuggestionIndex(workspaceIndex);
    } else if (currentCounter !== undefined) {
        calculatedIndex = currentCounter;
    }
</script>

<button
    on:click={() => onSelect(collaborator)}
    class="suggestion-option"
    class:option-selected={selectedIndex === calculatedIndex}
    bind:this={refElement}
    style="height: {ELEMENT_HEIGHT}px"
>
    <div class="option-wrapper">
        {#if (collaborator.firstName && collaborator.firstName.trim() !== "") || (collaborator.lastName && collaborator.lastName.trim())}
            <p class="option-name">
                <span class="user-name">
                    {collaborator.firstName.trim()}
                    {collaborator.lastName.trim()}
                </span>
            </p>
            <p class="option-username">
                {collaborator.username}
            </p>
        {:else}
            <p class="option-name">
                <span class="user-name">{collaborator.username}</span>
            </p>
        {/if}
    </div>
</button>

<style>
    .suggestion-option {
        @apply mb-1 flex w-full shrink-0 cursor-pointer scroll-mb-1 scroll-mt-9 flex-col justify-center rounded border-none bg-white px-1.5 outline-none hover:bg-gray-100 !important;
    }

    .option-wrapper {
        @apply w-full text-left !important;
    }

    .option-name {
        @apply m-0 block overflow-hidden text-ellipsis text-sm font-medium leading-4 text-black !important;
    }

    .option-username {
        @apply m-0 text-xs text-gray-500 !important;
    }

    .user-name {
        @apply overflow-hidden text-ellipsis whitespace-nowrap !important;
    }

    .option-selected {
        background-color: #f3f4f6 !important;
    }
</style>
